import { HttpInterceptorFn, HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { OauthService } from '../services/oauth.service';
import { ContextService } from '../services/context.service';
import { environment } from '../../environments/environment';

const GNEXUS_URL = /\/(seeds|seed-dispatch-orders|seed-tags|lot-assignments|seed-backoffice)\/|\/gnexus-health\/status(?:\?|$)/;
const EXCLUDED_URL = /\/seeds\/user-context(?:\?|$)/;
const BODY_METHODS = new Set(['POST', 'PUT', 'PATCH']);

const isPlainObject = (body: unknown): body is Record<string, unknown> =>
  body !== null && typeof body === 'object' && Object.getPrototypeOf(body) === Object.prototype;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const oauthService = inject(OauthService);
  const plant = inject(ContextService).active();
  const token = oauthService.getToken();

  let headers = req.headers
    .set('X-API-KEY', environment.apiKey)
    .set('X-API-NAME', environment.apiName);

  if (token) {
    headers = headers.set('Authorization', `Bearer ${token}`);
  }

  const target = plant && GNEXUS_URL.test(req.url) && !EXCLUDED_URL.test(req.url) ? plant : null;
  let request: HttpRequest<unknown>;
  if (target && req.method === 'GET') {
    request = req.clone({
      headers,
      setParams: { Empresa_Codigo: String(target.companyCode), Planta_Codigo: String(target.plantCode) },
    });
  } else if (target && BODY_METHODS.has(req.method) && (req.body === null || isPlainObject(req.body))) {
    request = req.clone({
      headers,
      body: { ...req.body, Empresa_Codigo: target.companyCode, Planta_Codigo: target.plantCode },
    });
  } else {
    request = req.clone({ headers });
  }

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      // Con mockData el token es local y el backend siempre lo rechaza: no se cierra la sesión.
      if (!environment.mockData && (error.status === 401 || error.status === 408 || error.status === 0)) {
        oauthService.refreshToken();
      }
      return throwError(() => error);
    })
  );
};
